
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { sdgsData } from "@/data/sdgs";
import { useMedia } from "./context";

const MediaModal: React.FC = () => {
  const { language } = useLanguage();
  const { selectedMedia, setSelectedMedia } = useMedia();

  if (!selectedMedia) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" 
      onClick={() => setSelectedMedia(null)}
    >
      <div 
        className="relative bg-white rounded-xl overflow-hidden max-w-4xl w-full max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-4 flex justify-between items-center border-b">
          <h3 className="text-xl font-bold">
            {language === "en" ? selectedMedia.title.en : selectedMedia.title.ar}
          </h3>
          <button 
            onClick={() => setSelectedMedia(null)}
            className="p-1 rounded-full hover:bg-palsustain-beige/20 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="flex-1 overflow-auto">
          {selectedMedia.type === "video" ? (
            <div className="relative pt-[56.25%]">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src={selectedMedia.videoUrl}
                title={language === "en" ? selectedMedia.title.en : selectedMedia.title.ar}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <div className="h-full flex items-center justify-center bg-palsustain-charcoal/5 p-4">
              <img 
                src={selectedMedia.image} 
                alt={language === "en" ? selectedMedia.title.en : selectedMedia.title.ar}
                className="max-h-[70vh] object-contain"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src = "https://via.placeholder.com/800x600?text=Image+Not+Found";
                }}
              />
            </div>
          )}
        </div>
        
        <div className="p-4 border-t flex items-center">
          <div 
            className="w-8 h-8 mr-2 rounded-full flex items-center justify-center text-sm font-medium text-white"
            style={{ backgroundColor: sdgsData.find(sdg => sdg.id === selectedMedia.sdgId)?.color || "#999" }}
          >
            {selectedMedia.sdgId}
          </div>
          <span className="text-palsustain-charcoal/70">
            {sdgsData.find(sdg => sdg.id === selectedMedia.sdgId)?.title[language]}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MediaModal;
